// Static content for Tanonshop marketing site

export const IMG = {
  heroLiving: "https://images.unsplash.com/photo-1767584394169-cb62eccfe930?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwbGl2aW5nJTIwcm9vbSUyMGN1c2hpb258ZW58MHx8fHwxNzgzODc0MzY2fDA&ixlib=rb-4.1.0&q=85",
  cushions2: "https://images.unsplash.com/photo-1553114552-c4ece3a33c93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwbGl2aW5nJTIwcm9vbSUyMGN1c2hpb258ZW58MHx8fHwxNzgzODc0MzY2fDA&ixlib=rb-4.1.0&q=85",
  sewing: "https://images.unsplash.com/photo-1606501126768-b78d4569d3f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxzZXdpbmclMjBmYWJyaWMlMjBjcmFmdHNtYW5zaGlwfGVufDB8fHx8MTc4Mzg3NDM2N3ww&ixlib=rb-4.1.0&q=85",
  tools: "https://images.unsplash.com/photo-1578353022142-09264fd64295?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxzZXdpbmclMjBmYWJyaWMlMjBjcmFmdHNtYW5zaGlwfGVufDB8fHx8MTc4Mzg3NDM2N3ww&ixlib=rb-4.1.0&q=85",
  rv: "https://images.unsplash.com/photo-1519980744-785dc86d4a7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxjYW1wZXIlMjBydiUyMGludGVyaW9yJTIwbW9kZXJufGVufDB8fHx8MTc4Mzg3NDM2Nnww&ixlib=rb-4.1.0&q=85",
  womanCushions: "https://images.pexels.com/photos/7218188/pexels-photo-7218188.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  plantPillows: "https://images.pexels.com/photos/7885120/pexels-photo-7885120.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  whitePillow: "https://images.unsplash.com/photo-1629078692974-a778fc29497b",
  patio: "https://images.unsplash.com/photo-1761534602786-ebebdd9e9c0d",
  pinning: "https://images.unsplash.com/photo-1457972657980-4c9fddebec8d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  machine: "https://images.unsplash.com/photo-1641320197434-6ae0ca235048?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const COWHIDE = {
  texture: "https://static.prod-images.emergentagent.com/jobs/8345f4cd-053d-49b8-82e6-17c40992e974/images/54067f265ad697290dfe93b70b1e72b94988c98891a6371d21766d6c4d49dbc9.png",
  photos: [
    "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/sprmsih6_IMG_9091.PNG",
    "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/1tl4e6mo_IMG_9119.PNG",
    "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/cw06w9vh_IMG_6441.jpg",
    "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/hs2cu0z7_IMG_6385.jpg",
    "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/qu2c7xan_IMG_0721.jpg",
  ],
};

export const FABRICS = [
  { id: "cowhide", label: "Cowhide-Print Suede", swatch: COWHIDE.texture, desc: "Selected cowhide prints and solid suede colors." },
  { id: "linen", label: "Linen", swatch: "https://static.prod-images.emergentagent.com/jobs/8345f4cd-053d-49b8-82e6-17c40992e974/images/83d4e3ef858f6aefe0df4412133e7ca9c383ee3a0ec475ed45ed2db1bd5e6041.png", desc: "A clean, timeless choice for residential seating, benches and couches." },
  { id: "duck", label: "Duck Canvas", swatch: "https://static.prod-images.emergentagent.com/jobs/8345f4cd-053d-49b8-82e6-17c40992e974/images/d467b3f2892d5be9d9cce1d80c56ac267a1ab41481f93f241343208418d762b2.png", desc: "A durable, practical choice for campers, RVs and high-use areas." },
  { id: "com", label: "My Own Fabric (COM)", swatch: null, desc: "Ship your fabric to us or send a link for review." },
];

export const FABRIC_LINES = {
  cowhide: {
    id: "cowhide", name: "Cowhide-Print Suede", short: "Cowhide Suede",
    tagline: "Buttery-soft faux suede in bold cowhide prints and rich solid suedes. Mix a print top with a solid side for a custom two-tone look.",
    hero: COWHIDE.photos[0], photos: COWHIDE.photos, dualTone: true,
    colors: [
      { id: "brown-cowhide", label: "Brown Cowhide Suede", swatch: COWHIDE.texture },
      { id: "black-cowhide", label: "Black Cowhide Suede", swatch: "https://static.prod-images.emergentagent.com/jobs/8345f4cd-053d-49b8-82e6-17c40992e974/images/0eb54a40094c7dc48fed36b5a351e18e5eb58eefd0b671dd2650e7a2b3a28eeb.png" },
      { id: "plain-brown", label: "Plain Brown Suede", color: "#6b4a2f" },
      { id: "plain-black", label: "Plain Black Suede", color: "#211c19" },
    ],
  },
  linen: {
    id: "linen", name: "Linen", short: "Linen",
    tagline: "A clean, timeless natural fibre — a residential favourite for couches, benches and window seats.",
    hero: "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/uasf8cko_linen%20chair.jpg",
    photos: [
      "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/uasf8cko_linen%20chair.jpg",
      "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/vet7bjwz_linen%20cover.jpg",
      "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/ee5xjhsn_linen%203.jpg",
      "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/99sr3yx7_linen%204.jpg",
    ], dualTone: false,
    colors: [
      { id: "off-white", label: "Off White", color: "#efeadd" },
      { id: "oatmeal", label: "Oatmeal", swatch: "https://static.prod-images.emergentagent.com/jobs/8345f4cd-053d-49b8-82e6-17c40992e974/images/83d4e3ef858f6aefe0df4412133e7ca9c383ee3a0ec475ed45ed2db1bd5e6041.png" },
    ],
  },
  duck: {
    id: "duck", name: "Duck Canvas", short: "Duck Canvas",
    tagline: "Heavy, hard-wearing 10oz cotton canvas — built for campers, RVs, patios and high-use spaces.",
    hero: IMG.rv, photos: [IMG.rv, IMG.patio, IMG.cushions2], dualTone: false,
    colors: [
      { id: "natural-10oz", label: "10oz Natural", swatch: "https://static.prod-images.emergentagent.com/jobs/8345f4cd-053d-49b8-82e6-17c40992e974/images/d467b3f2892d5be9d9cce1d80c56ac267a1ab41481f93f241343208418d762b2.png" },
      { id: "red", label: "Red", color: "#9b2d2a" },
      { id: "blue", label: "Blue", color: "#2e4a6b" },
      { id: "brown", label: "Brown", color: "#6e4b34" },
      { id: "green", label: "Green", color: "#3e5140" },
      { id: "pink", label: "Pink", color: "#c98a94" },
    ],
  },
  faux: {
    id: "faux", name: "Faux Leather", short: "Faux Leather",
    tagline: "Vegan Leather — a durable, upholstery-grade synthetic leather with the look and feel of genuine leather. Easy to clean, pet-friendly, and an excellent choice for custom cushion covers, benches, RVs and dining seats. It contains no animal leather.",
    hero: "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/emnmb4ni_leather%20chair.jpg",
    photos: [
      "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/emnmb4ni_leather%20chair.jpg",
      "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/inod6qnj_faux%20leather%20chair%20both%20side.jpg",
      "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/tnxyp8qj_faux%20leather%201.webp",
      "https://customer-assets.emergentagent.com/job_tanonshop-preview/artifacts/ejfwem4u_Faux%20leather%202.webp",
    ], dualTone: false,
    colors: [
      { id: "black", label: "Black", color: "#181615" },
      { id: "brown", label: "Brown", color: "#5a3a24" },
      { id: "dark-brown", label: "Dark Brown", color: "#3a271a" },
    ],
  },
};

export const FABRIC_LINE_ORDER = ["cowhide", "linen", "duck", "faux"];

export const PRODUCTS = [
  {
    id: "sofa-couch",
    name: "Sofa & Couch Cushions",
    tag: "Living Room",
    desc: "Bench seats, back cushions and box-edge covers cut to your exact frame with hidden zippers and crisp piping.",
    image: IMG.womanCushions,
  },
  {
    id: "rv-camper",
    name: "RV & Camper Cushions",
    tag: "On the Road",
    desc: "Dinette booths, bunk pads and odd-shaped nooks. We template your rig for a factory-perfect refit.",
    image: IMG.rv,
  },
  {
    id: "window-bench",
    name: "Window & Bench Seats",
    tag: "Nooks",
    desc: "Reading nooks, mudroom benches and bay windows finished with tailored corners and welt cord.",
    image: IMG.whitePillow,
  },
  {
    id: "outdoor-patio",
    name: "Outdoor & Patio",
    tag: "Weatherproof",
    desc: "Fade- and water-resistant marine-grade fabrics built to survive full seasons outdoors.",
    image: IMG.patio,
  },
  {
    id: "throw-pillows",
    name: "Decorative Throw Pillows",
    tag: "Accents",
    desc: "Custom sizes, trims and closures to accent any room with your chosen fabric.",
    image: IMG.plantPillows,
  },
  {
    id: "boat-marine",
    name: "Boat & Marine Cushions",
    tag: "Marine",
    desc: "Helm seats, cockpit and cabin cushions in durable, quick-dry, UV-stable materials.",
    image: IMG.cushions2,
  },
];

export const GALLERY = [
  { id: 1, image: IMG.heroLiving, span: "lg:col-span-7 lg:row-span-2", alt: "Living room sofa with tailored cushions", label: "Living Room Refit" },
  { id: 2, image: IMG.plantPillows, span: "lg:col-span-5", alt: "Set of botanical throw pillows", label: "Botanical Accent Set" },
  { id: 3, image: IMG.rv, span: "lg:col-span-5", alt: "Modern camper interior cushions", label: "Camper Dinette" },
  { id: 4, image: IMG.whitePillow, span: "lg:col-span-6", alt: "White custom cushion on chair", label: "Window Bench" },
  { id: 5, image: IMG.cushions2, span: "lg:col-span-6", alt: "Assorted throw pillows on sofa", label: "Sofa Cushion Collection" },
  { id: 6, image: IMG.womanCushions, span: "lg:col-span-7", alt: "Arranging cushions on couch", label: "Family Room" },
  { id: 7, image: IMG.patio, span: "lg:col-span-5", alt: "Outdoor patio seating cushions", label: "Patio Set" },
];

export const HIGHLIGHTS = [
  { icon: "ruler", title: "Made to Measure", body: "Every cover is cut to your exact dimensions — no stretching, no sagging, no compromise." },
  { icon: "scissors", title: "20+ Years Handcrafted", body: "Two decades at one workbench. Every seam, zipper and welt is finished by hand." },
  { icon: "layers", title: "Premium Fabrics", body: "Upholstery-, marine- and outdoor-grade textiles chosen to last another twenty years." },
  { icon: "sparkles", title: "Quote, Not Checkout", body: "We build to your project, so pricing is personal. Send measurements for a free custom quote." },
];

export const FAQS = [
  { q: "How do I get a price?", a: "Tanonshop doesn't sell fixed items off a shelf. Fill out the Custom Order form with your measurements, project type and (optionally) photos, and we'll email a personalized quote — no obligation, no payment required online." },
  { q: "How should I measure my cushions?", a: "Measure width, depth and thickness (height) of each cushion in inches, from seam to seam. For odd shapes, add a photo with a tape measure in frame. We'll confirm everything before starting." },
  { q: "Can you match my existing fabric?", a: "In most cases, yes. Send a clear photo and, if possible, the fabric name or a swatch. We carry a wide range of upholstery, outdoor and marine fabrics and can help you choose." },
  { q: "Do you work with RV and boat owners?", a: "Absolutely — it's one of our specialties. Custom-fit dinette, bunk, cockpit and cabin cushions are a large part of our work. Templating instructions are provided after your quote." },
  { q: "How long does an order take?", a: "Most projects are completed within 2–4 weeks after fabric selection and measurement confirmation. Larger or intricate jobs may take longer; we'll always give you a timeline up front." },
  { q: "How do payments work?", a: "There is no online checkout. Once your quote is approved, we arrange payment directly (invoice, check or transfer) before production begins." },
  { q: "Do you ship?", a: "Yes. We ship completed covers nationwide. Shipping is calculated and included in your final quote." },
];

export const NAV_LINKS = [
  { to: "/covers", label: "Custom Covers" },
  { to: "/shop", label: "Shop" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/reviews", label: "Reviews" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];
